export enum CookieConsentTexts {
    LINK = "Узнать подробнее",
    APPROVE = "Принять"
}